"use strict";

angular.module("vendor")
.controller("CreateUserCustomerController", function(
    $scope, $attrs, close, gettextCatalog, FormError, Language, FlashBag, PatternService, PartnershipService,
    EMAIL_MAXLENGTH
) {
    var _this = this;
    $scope.userCustomer = {
        language: $attrs.defaultLanguage,
        time_zone: $attrs.defaultTimeZone
    };
    $scope.title = $attrs.title;
    $scope.partnershipId = $attrs.partnershipId;

    Language.getLanguages().then(function(response) {
        $scope.languages = response.data;
    });

    $scope.pattern = PatternService;
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    this.confirm = function() {
        $scope.isSubmitButtonDisabled = true;
        $scope.createManagerForm.$setSubmitted();
        FormError.focus("createManagerForm");
        if (!$scope.createManagerForm.$valid) {
            $scope.isSubmitButtonDisabled = false;
            return;
        }
        PartnershipService.createManager($scope.partnershipId, $scope.userCustomer)
        .then(
            function onSuccess() {
                _this.close(true);
                FlashBag.success(gettextCatalog.getString("The manager was created successfully."), true);
            },
            function onError(response) {
                $scope.isSubmitButtonDisabled = false;
                if (response.data && response.data.complex_scenario) {
                    FlashBag.apiError(response);
                    _this.close();
                }
                else {
                    var errorMessage = FlashBag.formatErrorResponse(response);
                    FlashBag.alertWithContainer("danger", "flash-create-manager-modal", errorMessage);
                }
            }
        );
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/customer/modals/create-user-customer-manager.modal.js
// module id = 902
// module chunks = 0